import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { routes } from './routes';

const App = () =>
{
	const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
	return <BrowserRouter children={routes} basename={baseUrl} />
}

export default App;